export default "__VITE_ASSET__A$FD35La__"